import React, { Component } from "react";
import { Motion, spring, presets } from "react-motion";
import Tip from "../utility/tip";
import Invoice from "../../../models/invoice";
import SelectMenu from "../utility/select-menu";
import productStore from "../../store/product-store";
import InvoiceDetail from "../../../models/invoice-detail";
import QuestionBox from "../utility/question-box";
import * as invoiceAction from "../../actions/invoice-action";
//import { invoiceConstant } from "../../constants/constants";



export default class CreateInvoice extends Component {
    constructor() {
        super();
        this.state = {
            greenLeft: 0,
            yellowLeft: 0,
            propError: {},
            productList: productStore.getAll(),
            slideInvoice: false,

        };

        this.invoice = new Invoice({});
        this.invoiceDetail = new InvoiceDetail({});

        this.cancel = this.cancel.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.invoiceBox = null;
        this.invoiceDetailBox = null;
        this.invoiceDetailList = [];
        this.questionBox = null;
        this.productIdMenuReset = false;

    }

    cancel() {
        this.props.hide();
    }

    validate(propToCheck, model, value) {
        this[model][propToCheck] = value;
        var propError = Object.assign({}, this.state.propError);
        if (this[model].getErrors()[propToCheck]) {
            propError[propToCheck] = true;
        } else {
            delete propError[propToCheck];
        }
        this.setState({ propError });
        //return propError;
    }

    onBlur(propToCheck, model) {
        var propError = Object.assign({}, this.state.propError);
        if (this[model].getErrors()[propToCheck]) {
            propError[propToCheck] = true;
        } else {
            delete propError[propToCheck];
        }
        this.setState({ propError });
    }

    onKeyUp(propToCheck, model, e) {
        this.validate(propToCheck, model, e.target.value);

    }

    onProductSelect(product) {
        this.selectedProduct = product;
        this.invoiceDetail.productName = product.productName;
        this.validate("productId", "invoiceDetail", product.productId);
    }


    addProduct() {
        if (!this.invoiceDetail.hasError()) {
            this.invoiceDetailList.push(this.invoiceDetail);
            this.invoiceDetail = new InvoiceDetail({});
            this.resetInvoiceDetail();
            this.productIdMenuReset = true;
            this.forceUpdate();
        } else {
            let propError = Object.assign({}, this.invoiceDetail.getErrors());
            this.setState({ propError });
        }
    }



    resetInvoiceDetail() {

        this.quantity.value = "";
        this.shortageQuantity.value = "";
        this.density.value = "";
        this.selectProduct.focus();

    }

    slideInvoice() {
        if (!this.invoice.hasError()) {
            // this.state.slideInvoice = true;
            this.selectProduct.focus();
            this.setState({ slideInvoice: true });
        } else {
            let propError = Object.assign({}, this.invoice.getErrors());
            this.setState({ propError });
        }

    }
    showSlider() {
        if (this.state.slideInvoice) {
            this.setState({ invoiceSmallSlider: true });
        }
    }
    invoiceSmallSliderClick() {
        let slideInvoice = !this.state.slideInvoice;
        this.setState({ invoiceSmallSlider: false, slideInvoice });
    }

    componentDidUpdate() {
        this.productIdMenuReset = false;

    }
    componentDidMount() {
        this.invoiceNumber.focus();
    }
    askQuestion(msg, yesCallBack, noCallBack) {
        this.questionBox = <QuestionBox questionMsg={msg} yesCallBack={yesCallBack} noCallBack={noCallBack}></QuestionBox>;
        this.setState(this.state);
    }

    handleSubmit() {
        let propError = {};
        this.askQuestion(`Do you want to create invoice ${this.invoice.invoiceNumber} ?`, () => {
            this.props.showSpinner();
            invoiceAction.createInvoice({ invoice: this.invoice, invoiceDetails: this.invoiceDetailList });
            this.questionBox = null;

            this.setState({ propError });
        }, () => {
            this.questionBox = null;
            this.setState({ propError });
        });

    }



    render() {
        return (
            <div>
                {this.questionBox}
                {this.messageBox}
                <Motion defaultStyle={{ a: 0 }} style={{ a: spring(1, presets.stiff) }}>
                    {({ a }) => {
                        return (
                            <div className="flyHolder boxShadow" style={{ transform: `scale(${a})` }}>


                                <Motion defaultStyle={{ x: 0 }} style={{ x: spring(this.state.slideInvoice ? -100 : 0) }} onRest={this.showSlider.bind(this)}>
                                    {({ x }) => {

                                        return (
                                            <div className="flatBox" style={{ backgroundColor: "white", zIndex: 1003, left: `${x}%` }} ref={(x) => { this.invoiceBox = x; }}>
                                                <div style={{ height: "50px", background: "#23b9fd", width: "100%" }}></div>
                                                <div style={{ position: "absolute", top: "80px", marginRight: "auto", marginLeft: "auto" }}>

                                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                                        <div style={{ paddingRight: "10px" }}>
                                                            <table className="formTable">
                                                                <tbody>
                                                                    <tr>
                                                                        <td>

                                                                            <p className="whitePara">Invoce Number</p>
                                                                            <Tip
                                                                                showOn={this.state.propError.invoiceNumber}
                                                                                pointerStyle={{}}
                                                                                msg={this.invoice.getErrors().invoiceNumber}
                                                                            />
                                                                            <input
                                                                                type="text"
                                                                                className="formControl inputBox"
                                                                                onBlur={this.onKeyUp.bind(this, "invoiceNumber", "invoice")}
                                                                                onKeyUp={this.onKeyUp.bind(this, "invoiceNumber", "invoice")}
                                                                                tabIndex="101"
                                                                                ref={(x) => { this.invoiceNumber = x; }}
                                                                            />

                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>

                                                                            <p className="whitePara">Invoce Date</p>
                                                                            <Tip
                                                                                showOn={this.state.propError.invoiceDateTime}
                                                                                pointerStyle={{}}
                                                                                msg={this.invoice.getErrors().invoiceDateTime}
                                                                            />
                                                                            <input
                                                                                type="datetime-local"
                                                                                className="formControl inputBox"
                                                                                ref="invoiceDateTime"
                                                                                onBlur={this.onBlur.bind(this, "invoiceDateTime", "invoice")}
                                                                                onKeyUp={this.onKeyUp.bind(this, "invoiceDateTime", "invoice")}
                                                                                onClick={this.onKeyUp.bind(this, "invoiceDateTime", "invoice")}
                                                                                tabIndex="102"

                                                                            />

                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>

                                                                            <p className="whitePara">Receive Date</p>
                                                                            <Tip
                                                                                showOn={this.state.propError.receiveDateTime}
                                                                                pointerStyle={{}}
                                                                                msg={this.invoice.getErrors().receiveDateTime}

                                                                            />

                                                                            <input
                                                                                type="datetime-local"
                                                                                className="formControl inputBox"
                                                                                ref="receiveDateTime"
                                                                                onBlur={this.onBlur.bind(this, "receiveDateTime", "invoice")}
                                                                                onKeyUp={this.onKeyUp.bind(this, "receiveDateTime", "invoice")}
                                                                                onClick={this.onKeyUp.bind(this, "receiveDateTime", "invoice")}
                                                                                tabIndex="103"
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>

                                                                            <p className="whitePara">Invoice Amount</p>
                                                                            <Tip
                                                                                showOn={this.state.propError.invoiceAmount}
                                                                                pointerStyle={{}}
                                                                                msg={this.invoice.getErrors().invoiceAmount}
                                                                            />
                                                                            <input
                                                                                type="number"
                                                                                className="formControl inputBox"
                                                                                ref="invoiceAmount"
                                                                                onBlur={this.onBlur.bind(this, "invoiceAmount", "invoice")}
                                                                                onKeyUp={this.onKeyUp.bind(this, "invoiceAmount", "invoice")}
                                                                                tabIndex="104"
                                                                            />

                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>

                                                        </div>
                                                        <div>
                                                            <table className="formTable">
                                                                <tbody>
                                                                    <tr>
                                                                        <td>
                                                                            <p className="whitePara">Transport Name</p>
                                                                            <input
                                                                                type="text" className="formControl inputBox"
                                                                                ref="transportName"
                                                                                onKeyUp={this.onKeyUp.bind(this, "transportName", "invoice")}
                                                                                onBlur={this.onBlur.bind(this, "transportName", "invoice")}
                                                                                tabIndex="105"
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>
                                                                            <p className="whitePara">Lorry Number</p>
                                                                            <Tip
                                                                                showOn={this.state.propError.truckNumber}
                                                                                pointerStyle={{}}
                                                                                msg={this.invoice.getErrors().truckNumber}
                                                                            />
                                                                            <input type="text" className="formControl inputBox" ref="lorryNumber"
                                                                                onBlur={this.onBlur.bind(this, "truckNumber", "invoice")}
                                                                                onKeyUp={this.onKeyUp.bind(this, "truckNumber", "invoice")}
                                                                                tabIndex="106"
                                                                            />

                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>
                                                                            <p className="whitePara">Driver Contact No</p>
                                                                            <input
                                                                                type="text"
                                                                                className="formControl inputBox"
                                                                                ref="truckDriverPhone"
                                                                                onKeyUp={this.onKeyUp.bind(this, "truckDriverPhone", "invoice")}
                                                                                onBlur={this.onBlur.bind(this, "truckDriverPhone", "invoice")}
                                                                                tabIndex="107"
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>

                                                                            <p className="whitePara">Comment</p>
                                                                            <input type="text" className="formControl inputBox" ref="comment" onKeyUp={this.onKeyUp.bind(this, "comment", "invoice")}
                                                                                onBlur={this.onBlur.bind(this, "comment", "invoice")}
                                                                                tabIndex="108"
                                                                            />

                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>

                                                        </div>
                                                    </div>
                                                </div>

                                                <i tabIndex="109" className="fa fa-chevron-circle-left" aria-hidden="true" onKeyDown={(e) => { if (e.keyCode === 13) this.slideInvoice(); }} onClick={this.slideInvoice.bind(this)} style={{ position: "absolute", color: "#23b9fd", right: "90px", bottom: "10px", fontSize: "4em", cursor: "pointer" }}></i>
                                            </div>
                                        );
                                    }}

                                </Motion>


                                <div className="flatBox" style={{ background: "white", zIndex: 1002, left: 0 }} ref={(x) => { this.invoiceDetailBox = x; }} >
                                    <div style={{ height: "50px", background: "#23b9fd", width: "100%" }}></div>
                                    <div style={{ position: "absolute", top: "45%", left: "50%", transform: "translate(-50%,-70%)" }}>

                                        <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                                            <div style={{ paddingRight: "10px" }}>

                                                <table className="formTable">
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <p className="whitePara">Select a product</p>
                                                                <Tip
                                                                    showOn={this.state.propError.productId}
                                                                    pointerStyle={{}}
                                                                    msg={"Please select a product"}
                                                                />
                                                                <SelectMenu
                                                                    data={this.state.productList}
                                                                    onSelect={this.onProductSelect.bind(this)}
                                                                    tabIndex="110"
                                                                    text="Select a product"
                                                                    onBlur={this.validate.bind(this, "productId", "invoiceDetail")}
                                                                    ky="productId"
                                                                    vl="productName"
                                                                    reset={this.productIdMenuReset}
                                                                    rex={(x) => { this.selectProduct = x; }}
                                                                >
                                                                </SelectMenu>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>

                                                                <p className="whitePara">Quantity in KL</p>
                                                                <Tip
                                                                    showOn={this.state.propError.quantity}
                                                                    pointerStyle={{}}
                                                                    msg={"Please enter quantity in K.L"}
                                                                />
                                                                <input
                                                                    type="number"
                                                                    className="formControl inputBox"
                                                                    onBlur={this.onBlur.bind(this, "quantity", "invoiceDetail")}
                                                                    onKeyUp={this.onKeyUp.bind(this, "quantity", "invoiceDetail")}
                                                                    ref={(x) => { this.quantity = x; }}
                                                                    tabIndex="111"
                                                                />

                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <p className="whitePara">Shortage Quantity in Ltrs.</p>
                                                                <Tip
                                                                    showOn={this.state.propError.shortageQuantity}
                                                                    pointerStyle={{}}
                                                                    msg={"Please enter shortage quantity in Ltrs."}
                                                                />
                                                                <input
                                                                    type="number"
                                                                    className="formControl inputBox"
                                                                    onBlur={this.onBlur.bind(this, "shortageQuantity", "invoiceDetail")}
                                                                    onKeyUp={this.onKeyUp.bind(this, "shortageQuantity", "invoiceDetail")}
                                                                    ref={(x) => { this.shortageQuantity = x; }}
                                                                    tabIndex="112"
                                                                />

                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                            <div>
                                                <table className="formTable">
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <p className="whitePara">Density</p>
                                                                <Tip
                                                                    showOn={this.state.propError.density}
                                                                    pointerStyle={{}}
                                                                    msg={"Please enter base density"}
                                                                />
                                                                <input
                                                                    type="text"
                                                                    className="formControl inputBox"
                                                                    onBlur={this.onBlur.bind(this, "density", "invoiceDetail")}
                                                                    onChange={this.onKeyUp.bind(this, "density", "invoiceDetail")}
                                                                    ref={(x) => { this.density = x; }}
                                                                    tabIndex="115"
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <button tabIndex="117" style={{ margin: "5px 0 12px 0", display: this.invoiceDetailList.length >= 1 ? "block" : "none" }} onClick={this.handleSubmit.bind(this)} className="circleBtn btnRight"><i className="fa fa-check" aria-hidden="true"></i></button>
                                                <button tabIndex="116" style={{ margin: "5px 10px 12px 0" }} onClick={this.addProduct.bind(this)} className="circleBtn btnRight"><i className="fa fa-plus" aria-hidden="true"></i></button>
                                            </div>

                                        </div>

                                    </div>
                                    <div style={{ maxHeight: "150px", minHeight: "150px", overflowY: "scroll", position: "absolute", bottom: "10px", left: "5%", width: "90%" }}>
                                        <table width="100%" className="flatTable" >
                                            <thead>
                                                <tr>
                                                    <th>Product</th>
                                                    <th>Quantity K.L</th>
                                                    <th>Shortage Quantity Ltrs.</th>

                                                    <th>Density</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.invoiceDetailList.map((e, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td>{e.productName}</td>
                                                            <td>{e.quantity}</td>
                                                            <td>{e.shortageQuantity}</td>
                                                            <td>{e.density}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                    <i className="fa fa-arrow-circle-o-right"
                                        onClick={this.invoiceSmallSliderClick.bind(this)}
                                        style={{ position: "absolute", color: "#ffffff", top: "12px", left: "15px", fontSize: "2em", cursor: "pointer" }}>
                                    </i>
                                </div>

                            </div >
                        );
                    }
                    }
                </Motion >
                <div className="overlay" onClick={this.cancel}></div>
                {this.spinner}

            </div >
        );

    }
}



// WEBPACK FOOTER //
// ./src/jsx/components/fragments/create-invoice.jsx